import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, ReactNode } from 'react';
import { OptionLabel } from '@morpho-org/ui-v6/client';
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon } from '@repo/ui';
import { Check } from '@repo/ui/icons';
export interface SelectItemProps extends PropsWithChildren {
  value: string;
  selected: boolean;
  icon?: ReactNode;
  tag?: string;
  onItemClick: (value: string) => void;
}
export function SelectItem(t0) {
  const $ = _c(17);
  const {
    icon,
    value,
    children,
    selected,
    tag,
    onItemClick
  } = t0;
  let t1;
  if ($[0] !== onItemClick || $[1] !== value) {
    t1 = () => onItemClick(value);
    $[0] = onItemClick;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = selected ? "text-foreground" : "text-secondary-foreground";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("hover:bg-background hover:text-foreground px-xs py-2xs flex cursor-pointer items-center justify-between rounded-lg text-xs outline-none", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== icon || $[7] !== tag) {
    t4 = <OptionLabel icon={icon} tag={tag}>{children}</OptionLabel>;
    $[5] = children;
    $[6] = icon;
    $[7] = tag;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== selected) {
    t5 = selected && <Icon icon={<Check />} className="text-foreground" />;
    $[9] = selected;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== selected || $[12] !== t1 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div role="option" aria-selected={selected} onClick={t1} className={t3}>{t4}{t5}</div>;
    $[11] = selected;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}